import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTwitterLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 26,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2230_175)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.28571 0C1.025 0 0 1.025 0 2.28571V13.7143C0 14.975 1.025 16 2.28571 16H13.7143C14.975 16 16 14.975 16 13.7143V2.28571C16 1.025 14.975 0 13.7143 0H2.28571ZM12.8964 3L9.18929 7.23571L13.55 13H10.1357L7.46429 9.50357L4.40357 13H2.70714L6.67143 8.46786L2.48929 3H5.98929L8.40714 6.19643L11.2 3H12.8964ZM11.5464 11.9857L5.47857 3.96071H4.46786L10.6036 11.9857H11.5464Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2230_175",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgTwitterLogo;
